import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=bb573552&scoped=true"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"
import style0 from "./Strategy.vue?vue&type=style&index=0&id=bb573552&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb573552",
  null
  
)

export default component.exports